import React from 'react';
import { useCepAutocomplete } from '../../hooks/useCepAutocomplete';

interface CepAutocompleteWrapperProps {
    cepField: string;
    enderecoField: string;
    bairroField: string;
    cidadeField?: string;
    estadoField?: string;
    complementoField?: string;
    numeroField?: string;
    localizacaoField?: string;
    /** Suspende a consulta enquanto o formulário importa endereço de outro cadastro. */
    pausado?: boolean;
    onLoadingChange?: (loading: boolean) => void;
}

export default function CepAutocompleteWrapper(props: CepAutocompleteWrapperProps) {
    useCepAutocomplete(props);
    return null;
}
